export class DataPage {

    begin : number = 0;
    size: number = 10;
    data: any[];
    hasMore: boolean;
    
}
